import ReportPageHead from "@/reports/components/ReportPageHead";
import { ClassroomStudent } from "@/types/models/Classroom.interface";
import InsightsBreadcrumb from "./components/InsightsBreadcrumb";
import { BreadcrumbLink } from "./components/InsightsBreadcrumb/InsightsBreadcrumb";
import InsightsPageFilters from "./components/InsightsPageFilters";
import { pageHeaderTitleCss } from "./PageHeaderContainer.style";

export interface PageHeaderContainerProps {
  pageTitle: string;
  breadcrumbsLinks: BreadcrumbLink[];
  isClassroomReportPage?: boolean;
  studentList?: ClassroomStudent[];
  hideActivityFilter?: boolean;
  hideFilters?: boolean;
}

const PageHeaderContainer = ({
  breadcrumbsLinks,
  isClassroomReportPage = false,
  studentList,
  pageTitle,
  hideActivityFilter = false,
  hideFilters = false,
}: PageHeaderContainerProps) => {
  const pageHeadTitleSegments = breadcrumbsLinks
    .map((item) => item.contents)
    .reverse();

  return (
    <>
      <ReportPageHead titleSegments={pageHeadTitleSegments} />
      <InsightsBreadcrumb breadcrumbsLinks={breadcrumbsLinks} />
      <h1 css={pageHeaderTitleCss}>{pageTitle}</h1>
      {hideFilters ? null : (
        <InsightsPageFilters
          isClassroomReportPage={isClassroomReportPage}
          studentList={studentList}
          hideActivityFilter={hideActivityFilter}
        />
      )}
    </>
  );
};

export default PageHeaderContainer;
